import React from 'react';
import FaIcon from './FaIcon';
import {
  CLIENT_UPDATE_REQUIRED_CTA_LABEL,
  CLIENT_UPDATE_REQUIRED_MESSAGE,
} from '../api/client';
import styles from '../styles/ClientUpdateRequiredOverlay.module.css';

const ClientUpdateRequiredOverlay = ({
  isOpen,
  message = CLIENT_UPDATE_REQUIRED_MESSAGE,
  ctaLabel = CLIENT_UPDATE_REQUIRED_CTA_LABEL,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="client-update-required-title"
    >
      <div className={styles.panel}>
        <h2 id="client-update-required-title" className={styles.title}>
          Aggiornamento disponibile
        </h2>
        <p className={styles.message} data-testid="client-update-required-message">
          {message}
        </p>
        <button
          type="button"
          className={styles.reloadButton}
          onClick={handleReload}
          data-testid="client-update-required-cta"
        >
          <FaIcon className={`fas fa-refresh ${styles.reloadIcon}`} aria-hidden="true" />
          {ctaLabel}
        </button>
      </div>
    </div>
  );
};

export default ClientUpdateRequiredOverlay;
